export const Config = {
    'apiURL': 'https://api.madinigeita.co.tz/api/',
    // 'apiURL': 'https://madinigeita.co.tz/api/public/api/',
}